import { ErrorPageContent } from '@shared/components/error-page-content/error-page-content'
import { ClientError } from 'graphql-request'

export const ErrorPage = ({ error, message }: { error?: ClientError; message?: string }) => {
  const errorCode = error?.response?.status?.toString() || undefined
  return (
    <ErrorPageContent
      title={error?.name || 'Error'}
      message={message || error?.message || 'An error occurred.'}
      errorCode={errorCode}
    />
  )
}
